import throttle from 'lodash/throttle';
import {Store} from 'redux';

import type {RootState} from './store/ChatAppStore';

const LOCAL_CHAT_STORAGE_KEY = 'chatPreferences';

export function loadState() {
  try {
    const serialized = localStorage.getItem(LOCAL_CHAT_STORAGE_KEY);
    return serialized ? JSON.parse(serialized) : undefined;
  } catch (err) {
    // localStorage not supported don't care.
  }
}

export const throttledSaveStateToLocalStorage = throttle(
  (store: Store<RootState>) => {
    // save store state slices to localStorage on changes
    const state = store.getState();
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem(LOCAL_CHAT_STORAGE_KEY, serializedState);
    } catch (err) {
      // localStorage not supported
    }
  },
  2000
);
